import { z } from "zod";

export const CollectionSchema = z.object({
  name: z.string(),
  description: z.string(),
  id: z.string(),
  organization_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const ChatInCollectionSchema = z.object({
  added_by: z.string(),
  chat_id: z.string(),
  collection: CollectionSchema,
  collection_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  updated_at: z.string(),
});

export type Collection = z.infer<typeof CollectionSchema>;
export type ChatInCollection = z.infer<typeof ChatInCollectionSchema>;
